import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62496e35&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62496e35')) {
      api.createRecord('62496e35', component.options)
    } else {
      api.reload('62496e35', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62496e35&", function () {
      api.rerender('62496e35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/map/index.vue"
export default component.exports